import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';
import enabledStripeBilling from '../../constants/StripeBilling';
import Flags from '../../constants/Flags';
import { getTextBySystem as gts } from '../../utils';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  }
};

const enhance = compose();

const GochiTableHead = enhance(
  ({ order, orderBy, onRequestSort, totals, isFukuoka, educateSystem }) => {
    return (
      <TableHead>
        <TableRow>
          <TableCell sortDirection={orderBy === 'gochiBillNo' ? order : false}>
            <TableSortLabel
              active={orderBy === 'gochiBillNo'}
              direction={order}
              onClick={() => {
                onRequestSort('gochiBillNo');
              }}
            >
              {gts('領収書No', educateSystem)}
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'shopId' ? order : false}>
            <TableSortLabel
              active={orderBy === 'shopId'}
              direction={order}
              onClick={() => {
                onRequestSort('shopId');
              }}
            >
              {isFukuoka ? '教室ID' : '店舗ID'}
            </TableSortLabel>
          </TableCell>
          {!isFukuoka && (
            <TableCell sortDirection={orderBy === 'groupName' ? order : false}>
              <TableSortLabel
                active={orderBy === 'groupName'}
                direction={order}
                onClick={() => {
                  onRequestSort('groupName');
                }}
              >
                グループ名
              </TableSortLabel>
            </TableCell>
          )}
          <TableCell sortDirection={orderBy === 'shopName' ? order : false}>
            <TableSortLabel
              active={orderBy === 'shopName'}
              direction={order}
              onClick={() => {
                onRequestSort('shopName');
              }}
            >
              {isFukuoka ? '教室名' : '店舗名'}
            </TableSortLabel>
          </TableCell>

          <TableCell
            sortDirection={orderBy === 'streetAddress' ? order : false}
          >
            <TableSortLabel
              active={orderBy === 'streetAddress'}
              direction={order}
              onClick={() => {
                onRequestSort('streetAddress');
              }}
            >
              {isFukuoka ? '住所' : '住所'}
            </TableSortLabel>
          </TableCell>
          {!isFukuoka && (
            <TableCell
              sortDirection={orderBy === 'companyName' ? order : false}
            >
              <TableSortLabel
                active={orderBy === 'companyName'}
                direction={order}
                onClick={() => {
                  onRequestSort('companyName');
                }}
              >
                法人名
              </TableSortLabel>
            </TableCell>
          )}
          <TableCell sortDirection={orderBy === 'createdAt' ? order : false}>
            <TableSortLabel
              active={orderBy === 'createdAt'}
              direction={order}
              onClick={() => {
                onRequestSort('createdAt');
              }}
            >
              {gts('購入日', educateSystem)}
            </TableSortLabel>
          </TableCell>

          {!isFukuoka && (
            <TableCell
              sortDirection={orderBy === 'registerName' ? order : false}
            >
              <TableSortLabel
                active={orderBy === 'registerName'}
                direction={order}
                onClick={() => {
                  onRequestSort('registerName');
                }}
              >
                購入者
              </TableSortLabel>
            </TableCell>
          )}

          <TableCell
            sortDirection={orderBy === 'messageForShop' ? order : false}
          >
            <TableSortLabel
              active={orderBy === 'messageForShop'}
              direction={order}
              onClick={() => {
                onRequestSort('messageForShop');
              }}
            >
              {isFukuoka ? '教室への連絡' : '店舗へのメッセージ'}
            </TableSortLabel>
          </TableCell>
          {!isFukuoka && (
            <>
              <TableCell
                sortDirection={
                  orderBy === 'giftCardCategoryName' ? order : false
                }
              >
                <TableSortLabel
                  active={orderBy === 'giftCardCategoryName'}
                  direction={order}
                  onClick={() => {
                    onRequestSort('giftCardCategoryName');
                  }}
                >
                  ギフトカードカテゴリー
                </TableSortLabel>
              </TableCell>
              <TableCell
                sortDirection={orderBy === 'giftCardName' ? order : false}
              >
                <TableSortLabel
                  active={orderBy === 'giftCardName'}
                  direction={order}
                  onClick={() => {
                    onRequestSort('giftCardName');
                  }}
                >
                  ギフトカード名
                </TableSortLabel>
              </TableCell>
              <TableCell
                sortDirection={orderBy === 'gochiMessage' ? order : false}
              >
                <TableSortLabel
                  active={orderBy === 'gochiMessage'}
                  direction={order}
                  onClick={() => {
                    onRequestSort('gochiMessage');
                  }}
                >
                  ごちった時のメッセージ
                </TableSortLabel>
              </TableCell>
            </>
          )}

          {isFukuoka && (
            <TableCell sortDirection={orderBy === 'menuId' ? order : false}>
              <TableSortLabel
                active={orderBy === 'menuId'}
                direction={order}
                onClick={() => {
                  onRequestSort('menuId');
                }}
              >
                コースID
              </TableSortLabel>
            </TableCell>
          )}

          <TableCell sortDirection={orderBy === 'menuName' ? order : false}>
            <TableSortLabel
              active={orderBy === 'menuName'}
              direction={order}
              onClick={() => {
                onRequestSort('menuName');
              }}
            >
              {isFukuoka ? 'コース名' : 'メニュー名'}
            </TableSortLabel>
          </TableCell>

          {!isFukuoka && (
            <>
              <TableCell
                sortDirection={orderBy === 'gochiTypeStr' ? order : false}
              >
                <TableSortLabel
                  active={orderBy === 'gochiTypeStr'}
                  direction={order}
                  onClick={() => {
                    onRequestSort('gochiTypeStr');
                  }}
                >
                  ごち種別
                </TableSortLabel>
              </TableCell>
              <TableCell
                sortDirection={orderBy === 'gochiUserTypeStr' ? order : false}
              >
                <TableSortLabel
                  active={orderBy === 'gochiUserTypeStr'}
                  direction={order}
                  onClick={() => {
                    onRequestSort('gochiUserTypeStr');
                  }}
                >
                  ごち利用者種別
                </TableSortLabel>
              </TableCell>
            </>
          )}

          {enabledStripeBilling === true && <TableCell>購入頻度</TableCell>}

          <TableCell sortDirection={orderBy === 'couponCount' ? order : false}>
            <TableSortLabel
              active={orderBy === 'couponCount'}
              direction={order}
              onClick={() => {
                onRequestSort('couponCount');
              }}
            >
              個数
              <br />
              {`(計：${totals.couponCountTotal &&
                totals.couponCountTotal.toLocaleString()})`}
            </TableSortLabel>
          </TableCell>

          {!isFukuoka && (
            <TableCell
              sortDirection={orderBy === 'reducedTaxTypeStr' ? order : false}
            >
              <TableSortLabel
                active={orderBy === 'reducedTaxTypeStr'}
                direction={order}
                onClick={() => {
                  onRequestSort('reducedTaxTypeStr');
                }}
              >
                軽減税率対象
              </TableSortLabel>
            </TableCell>
          )}

          <TableCell sortDirection={orderBy === 'amount' ? order : false}>
            <TableSortLabel
              active={orderBy === 'amount'}
              direction={order}
              onClick={() => {
                onRequestSort('amount');
              }}
            >
              {isFukuoka ? '税抜金額' : '税抜価格'}
              <br />
              {isFukuoka
                ? `(計：${totals.externalAmountTotal &&
                    totals.externalAmountTotal.toLocaleString()})`
                : ''}
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'taxAmount' ? order : false}>
            <TableSortLabel
              active={orderBy === 'taxAmount'}
              direction={order}
              onClick={() => {
                onRequestSort('taxAmount');
              }}
            >
              {isFukuoka ? '税込金額' : '税込価格'}
              <br />
              {`(計：${totals.internalAmountTotal &&
                totals.internalAmountTotal.toLocaleString()})`}
            </TableSortLabel>
          </TableCell>
          {!isFukuoka && (
            <>
              <TableCell
                sortDirection={orderBy === 'discountAmount' ? order : false}
              >
                <TableSortLabel
                  active={orderBy === 'discountAmount'}
                  direction={order}
                  onClick={() => {
                    onRequestSort('discountAmount');
                  }}
                >
                  キャンペーン値引額
                  <br />
                  {`(計：${totals.discountAmountTotal &&
                    totals.discountAmountTotal.toLocaleString()})`}
                </TableSortLabel>
              </TableCell>
              <TableCell
                sortDirection={orderBy === 'depositPlanStr' ? order : false}
              >
                <TableSortLabel
                  active={orderBy === 'depositPlanStr'}
                  direction={order}
                  onClick={() => {
                    onRequestSort('depositPlanStr');
                  }}
                >
                  入金予定
                </TableSortLabel>
              </TableCell>
              <TableCell
                sortDirection={
                  orderBy === 'amountTransferToShopWhenBuy' ? order : false
                }
              >
                <TableSortLabel
                  active={orderBy === 'amountTransferToShopWhenBuy'}
                  direction={order}
                  onClick={() => {
                    onRequestSort('amountTransferToShopWhenBuy');
                  }}
                >
                  購入時の店舗振込額
                  <br />
                  {`(計：${totals.amountTransferToShopWhenBuyTotal &&
                    totals.amountTransferToShopWhenBuyTotal.toLocaleString()})`}
                </TableSortLabel>
              </TableCell>
            </>
          )}
          <TableCell sortDirection={orderBy === 'gochiStatus' ? order : false}>
            <TableSortLabel
              active={orderBy === 'gochiStatus'}
              direction={order}
              onClick={() => {
                onRequestSort('gochiStatus');
              }}
            >
              {isFukuoka ? '使用状況' : '使用状況'}
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'useDate' ? order : false}>
            <TableSortLabel
              active={orderBy === 'useDate'}
              direction={order}
              onClick={() => {
                onRequestSort('useDate');
              }}
            >
              {isFukuoka ? '使用日時' : '使用日時'}
            </TableSortLabel>
          </TableCell>
          {isFukuoka && (
            <TableCell sortDirection={orderBy === 'accountId' ? order : false}>
              <TableSortLabel
                active={orderBy === 'accountId'}
                direction={order}
                onClick={() => {
                  onRequestSort('accountId');
                }}
              >
                利用者ID
              </TableSortLabel>
            </TableCell>
          )}
          <TableCell
            sortDirection={orderBy === 'gochiUserName' ? order : false}
          >
            <TableSortLabel
              active={orderBy === 'gochiUserName'}
              direction={order}
              onClick={() => {
                onRequestSort('gochiUserName');
              }}
            >
              {isFukuoka ? '利用者名・コメント' : 'ごちられた人・メッセージ'}
            </TableSortLabel>
          </TableCell>
          {!isFukuoka && (
            <TableCell
              sortDirection={orderBy === 'couponShopMessage' ? order : false}
            >
              <TableSortLabel
                active={orderBy === 'couponShopMessage'}
                direction={order}
                onClick={() => {
                  onRequestSort('couponShopMessage');
                }}
              >
                レビューメッセージ
              </TableSortLabel>
            </TableCell>
          )}
          {!isFukuoka && (
            <>
              <TableCell>資金グループ名</TableCell>
              <TableCell>利用されたこどもID</TableCell>
              <TableCell>利用されたこども氏名</TableCell>
            </>
          )}
          <TableCell sortDirection={orderBy === 'useForShopId' ? order : false}>
            <TableSortLabel
              active={orderBy === 'useForShopId'}
              direction={order}
              onClick={() => {
                onRequestSort('useForShopId');
              }}
            >
              {isFukuoka ? '利用教室ID' : '使用された店舗ID'}
            </TableSortLabel>
          </TableCell>
          <TableCell
            sortDirection={orderBy === 'useForShopName' ? order : false}
          >
            <TableSortLabel
              active={orderBy === 'useForShopName'}
              direction={order}
              onClick={() => {
                onRequestSort('useForShopName');
              }}
            >
              {isFukuoka ? '利用教室名' : '使用された店舗名'}
            </TableSortLabel>
          </TableCell>
          {!isFukuoka && (
            <>
              <TableCell
                sortDirection={orderBy === 'couponUsedCount' ? order : false}
              >
                <TableSortLabel
                  active={orderBy === 'couponUsedCount'}
                  direction={order}
                  onClick={() => {
                    onRequestSort('couponUsedCount');
                  }}
                >
                  使用済み数
                  <br />
                  {`(計：${totals.couponUsedCountTotal &&
                    totals.couponUsedCountTotal.toLocaleString()})`}
                </TableSortLabel>
              </TableCell>
              <TableCell
                sortDirection={orderBy === 'usedExternalAmount' ? order : false}
              >
                <TableSortLabel
                  active={orderBy === 'usedExternalAmount'}
                  direction={order}
                  onClick={() => {
                    onRequestSort('usedExternalAmount');
                  }}
                >
                  使用済み税抜価格
                  <br />
                  {`(計：${totals.usedExternalAmountTotal &&
                    totals.usedExternalAmountTotal.toLocaleString()})`}
                </TableSortLabel>
              </TableCell>
              <TableCell
                sortDirection={orderBy === 'usedInternalAmount' ? order : false}
              >
                <TableSortLabel
                  active={orderBy === 'usedInternalAmount'}
                  direction={order}
                  onClick={() => {
                    onRequestSort('usedInternalAmount');
                  }}
                >
                  使用済み税込価格
                  <br />
                  {`(計：${totals.usedInternalAmountTotal &&
                    totals.usedInternalAmountTotal.toLocaleString()})`}
                </TableSortLabel>
              </TableCell>
              <TableCell
                sortDirection={orderBy === 'couponUsedCount' ? order : false}
              >
                <TableSortLabel
                  active={orderBy === 'couponUsedCount'}
                  direction={order}
                  onClick={() => {
                    onRequestSort('couponUsedCount');
                  }}
                >
                  使用済み数（合計）
                </TableSortLabel>
              </TableCell>
              <TableCell
                sortDirection={orderBy === 'usedInternalAmount' ? order : false}
              >
                <TableSortLabel
                  active={orderBy === 'usedInternalAmount'}
                  direction={order}
                  onClick={() => {
                    onRequestSort('usedInternalAmount');
                  }}
                >
                  使用済み税込価格（合計）
                </TableSortLabel>
              </TableCell>
              {Flags.showAddedAmountMenuLimitTotalAtSearchGochi && (
                <TableCell
                  sortDirection={orderBy === 'addedAmount' ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === 'addedAmount'}
                    direction={order}
                    onClick={() => {
                      onRequestSort('addedAmount');
                    }}
                  >
                    追加決済額
                  </TableSortLabel>
                </TableCell>
              )}
              <TableCell
                sortDirection={orderBy === 'couponNotUseAmount' ? order : false}
              >
                <TableSortLabel
                  active={orderBy === 'couponNotUseAmount'}
                  direction={order}
                  onClick={() => {
                    onRequestSort('couponNotUseAmount');
                  }}
                >
                  未使用額
                </TableSortLabel>
              </TableCell>
            </>
          )}
          <TableCell
            sortDirection={
              orderBy === 'amountTransferToShopWhenUse' ? order : false
            }
          >
            <TableSortLabel
              active={orderBy === 'amountTransferToShopWhenUse'}
              direction={order}
              onClick={() => {
                onRequestSort('amountTransferToShopWhenUse');
              }}
            >
              {isFukuoka ? '教室振込額' : '使用時の店舗振込額'}
              <br />
              {`(計：${totals.amountTransferToShopWhenUseTotal &&
                totals.amountTransferToShopWhenUseTotal.toLocaleString()})`}
            </TableSortLabel>
          </TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
    );
  }
);

export default withStyles(styles)(GochiTableHead);
